import PublicTeacherScholarInformationTable from "./PublicTeacherScholarInformationTable";

export default PublicTeacherScholarInformationTable